import React, {useEffect} from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css';
import hospital from '../Assets/hospital.png'
import observation from '../Assets/observation.png'
import school from '../Assets/school.png'
import industry from '../Assets/industry.png'
import { useNavigate } from 'react-router-dom';

export default function Feature() {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 1000 }); 
  }, []);
  
  return (
    <>
      <section id="featured-services" className="featured-services pt-5">
        <div className="container" data-aos="fade-up">
          <div className="row">
            <div className="col-md-3 d-flex align-items-stretch mb-5 mb-lg-0">
              <div className="icon-box" data-aos="fade-up" data-aos-delay="200">
                <div className="icon"><img src={school} alt="laptop" width="40" className="icon align-items-center" /></div>
                <h4 className="title">School Management Software</h4>
                <p className="description">Simplify school administration and communication using our all-in-one management software.</p><br/>
                <div className='d-flex justify-content-center align-items-center'>
                  <button type="button" className="btn btn-primary" onClick={() => navigate(`/School`)}>View Details</button>
                </div>
              </div>
            </div>
            <div className="col-md-3 d-flex align-items-stretch mb-5 mb-lg-0">
              <div className="icon-box" data-aos="fade-up" data-aos-delay="100">
                <div className="icon"><img src={observation} alt="laptop" width="40" className="icon align-items-center" /></div>
                <h4 className="title">Diagnostic Lab Management Software</h4>
                <p className="description">Efficiently streamline and manage diagnostic lab operations with our comprehensive software solution.</p><br/>
                <div className='d-flex justify-content-center align-items-center'>
                  <button type="button" className="btn btn-primary" onClick={() => navigate(`/Health`)}>View Details</button>
                </div>
              </div>
            </div>
            <div className="col-md-3 d-flex align-items-stretch mb-5 mb-lg-0">
              <div className="icon-box" data-aos="fade-up" data-aos-delay="300">
                <div className="icon"><img src={hospital} alt="laptop" width="40" className="icon align-items-center" /></div>
                <h4 className="title">Hospital Management Software</h4>
                <p className="description">Optimize healthcare facility operations seamlessly with our integrated hospital management software.</p><br/><br/>
                <div className='d-flex justify-content-center align-items-center'>
                  <button type="button" className="btn btn-primary" onClick={() => navigate(`/Hospital`)}>View Details</button>
                </div>
              </div>
            </div>
            <div className="col-md-3 d-flex align-items-stretch mb-5 mb-lg-0">
              <div className="icon-box" data-aos="fade-up" data-aos-delay="400">
                <div className="icon"><img src={industry} alt="laptop" width="40" className="icon align-items-center" /></div>
                <h4 className="title">Footwear Production Management</h4>
                <p className="description">Enhance footwear production efficiency through end-to-end management with our specialized ERP software.</p><br/>
                <div className='d-flex justify-content-center align-items-center'>
                  <button type="button" className="btn btn-primary" onClick={() => navigate(`/Tannery`)}>View Details</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
